export default "__VITE_ASSET__BngaPO6p__"